import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { getAllCategory } from '../actions';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { getCategoryDetailsById } from './../actions/category.action';
import { setCategoryDetails } from '../reducers/category.reducer';
import CategoryList from './../containers/Category/CategoryList';
import { generatePublicUrl } from '../urlConfig';

const ACTIVE_CAT_KEY = 'ACTIVE_CAT_SLUG';

const CategoryContainer = ({
    setShowActiveCategory,
    showAllProductsButton,
    setCategoryItem,
    variantRender,
    setPageNumber,
    categoryItem,
    slug,
    checked,
}) => {

    const category = useSelector((state) => state.category?.categories)
    const { visibleHiddenCategories } = useSelector((state) => state.category)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { slug: slugParam } = useParams()

    const [collapsed, setCollapsed] = useState(true)

    useEffect(() => {
        dispatch(getAllCategory())
    }, [visibleHiddenCategories, dispatch])

    useEffect(() => {
        const data = window.localStorage.getItem('TEST')
        setCategoryItem(JSON.parse(data))
    }, [setCategoryItem])

    useEffect(() => {
        if (slugParam) localStorage.setItem(ACTIVE_CAT_KEY, slugParam)
    }, [slugParam])

    if (!category) return null

    const activeSlug = slugParam || slug || localStorage.getItem(ACTIVE_CAT_KEY) || ''

    const editCategoryIndex = (category) => {
        setShowActiveCategory(category._id)
        setPageNumber(0)
    }
    const editChildrenCategoryIndex = (category) => {
        setCategoryItem(category)
        localStorage.setItem(ACTIVE_CAT_KEY, category.slug || '')
        dispatch(setCategoryDetails(category))
        dispatch(getCategoryDetailsById(category))
        navigate(`/products/${category.slug}`)
    }

    const renderFilter = (categories) => {
        return categories.map(category => (
            <div
                key={category.name}
                className="categoryContainer__mainContainer"
                onClick={() => editCategoryIndex(category)}
            >
                {category.parentId && (
                    <div
                        className={`categoryContainer__item${activeSlug === category.slug ? ' active' : ''}`}
                        onClick={(e) => { e.stopPropagation(); editChildrenCategoryIndex(category); }}
                    >
                        {category.name}
                        <img
                            src={generatePublicUrl(category.categoryImage)}
                            alt=""
                            loading="lazy"
                        />
                    </div>
                )}
                {category.children.length > 0 && (
                    <div className="categoryContainer__itemContainer">
                        {renderFilter(category.children)}
                    </div>
                )}
            </div>
        ));
    }

    const renderVariant = () => {
        if (variantRender === "productCategory") {
            return category.length > 0 ? renderFilter(category) : null
        }
        if (variantRender === "allCategory") {
            return (
                <CategoryList
                    editChildrenCategoryIndex={editChildrenCategoryIndex}
                    category={category}
                    categoryItem={categoryItem}
                    setCategoryItem={setCategoryItem}
                />
            )
        }
    }

    return (
        <div className={`categoryContainer ${collapsed ? 'is-collapsed' : ''}`}>
            <div className="categoryContainer__header">
                <button
                    type="button"
                    className="categoryContainer__toggle"
                    onClick={() => setCollapsed(v => !v)}
                    aria-expanded={!collapsed}
                >
                    <span className={`categoryContainer__chevron ${collapsed ? '' : 'rot'}`} aria-hidden>▾</span>
                    <span>Категории</span>
                </button>
            </div>

            <div className="categoryContainer__viewport">
                <div className="categoryContainer__linkContainer">
                    <div onClick={showAllProductsButton}>
                        <NavLink to="/products/all">#Все</NavLink>
                    </div>
                    {renderVariant()}
                </div>
            </div>
        </div>
    )
}

export default CategoryContainer
